import {createApp} from 'vue'
import App from './App.vue'
import router from "./router";
import {VueFire} from 'vuefire'
import {FireBaseApp} from "./firebase";

// Vuetify
import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import {createPinia} from "pinia";
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
    },
})

const app = createApp(App);
const pinia = createPinia()
app.use(VueFire, {
    FireBaseApp,
    modules: [],
});

app.use(vuetify).use(router).use(pinia).mount('#app');
